import { render } from "./4.HiTechServices.vue?vue&type=template&id=e1e60e60&scoped=true"
import script from "./4.HiTechServices.vue?vue&type=script&lang=js"
export * from "./4.HiTechServices.vue?vue&type=script&lang=js"

import "./4.HiTechServices.vue?vue&type=style&index=0&id=e1e60e60&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1e60e60"]])

export default __exports__